module.exports = __webpack_public_path__ + "img/sync_perfs.9867de9b.png";